export function CamFilledIcon() {
  return (
    <svg width='20' height='18' viewBox='0 0 20 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M4.18282 10.5051C3.99532 10.7757 4.06129 11.1482 4.32774 11.3361L4.73043 11.62C4.07317 12.2636 3.19172 12.6278 2.2711 12.6278H1.17188V11.3393C1.17188 11.0109 0.909532 10.7446 0.585938 10.7446C0.262344 10.7446 0 11.0109 0 11.3393V17.4053C0 17.7337 0.262344 18 0.585938 18C0.909532 18 1.17188 17.7337 1.17188 17.4053V16.1961H1.9661C4.06891 16.1961 6.12532 15.2986 7.5861 13.6328L8.17227 14.046C8.43841 14.2346 8.80762 14.1654 8.99063 13.8922L9.39219 13.2939L4.63868 9.84818L4.18282 10.5051Z'
        fill='#FCFCFD'
      />
      <path
        d='M19.7446 10.5583L19.5286 10.4084L15.0344 14.0531L16.3204 14.9928C16.5715 15.1762 16.9227 15.1299 17.1184 14.8834L19.87 11.423C20.0857 11.1516 20.0256 10.7528 19.7446 10.5583Z'
        fill='#FCFCFD'
      />
      <path
        d='M18.8347 8.48367L7.56793 0.225442C7.06188 -0.145575 6.35922 -0.0491531 5.96829 0.444769L2.26551 5.12252C1.84442 5.65462 1.9507 6.43864 2.49805 6.83539L12.4657 14.0601C12.6787 14.2144 12.9671 14.2068 13.1719 14.0407L18.8574 9.43044C19.1595 9.1855 19.149 8.71406 18.8347 8.48367ZM14.6875 9.53535C14.3639 9.53535 14.1016 9.26908 14.1016 8.94064C14.1016 8.61221 14.3639 8.34594 14.6875 8.34594C15.0111 8.34594 15.2734 8.61221 15.2734 8.94064C15.2734 9.26908 15.0111 9.53535 14.6875 9.53535Z'
        fill='#FCFCFD'
      />
    </svg>
  )
}
